import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {googleApiKey} from 'helpers/ApplicationHelper';
import ReadSign from 'components/chatBot/messageTypes/messageComponents/readSign';

// import { withGoogleMap, GoogleMap, Marker } from "react-google-maps";

class googleMapsMessage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            addressChanged: false
        };

        this.changeAddress = this.changeAddress.bind(this);
    }

    changeAddress() {
        if(this.state.addressChanged){
            return;
        }
        this.setState({addressChanged: true});
        this.props.changeAddress();
    }

    render(){
        let className = "message message-google-map fade-in" + (this.props.message.direction === 1 ? ' incoming' : ' outgoing') + (this.props.lastMessage ? ' last-message' : '');
        if(this.props.avatarTestMode){
            className += " avatar-message";
        }

        let text = this.props.message.text;
        let index = text.indexOf('<br>');
        text = text.substring(index > -1 ? index + 4 : 0);

        return (
            <div id={this.props.id} ref="googleMapMessage" className={className}>
                <a href={`http://maps.google.com/?q=${text}`} target="_blank">
                    <div className="map-wrapper"> 
                        <img src={`https://maps.googleapis.com/maps/api/staticmap?center=${this.props.message.lat},${this.props.message.lng}&zoom=16&size=300x150&maptype=roadmap&markers=color:red%7Clabel:A%7C${this.props.message.lat},${this.props.message.lng}&key=${googleApiKey}`} height={150} />
                    </div>
                    <span dangerouslySetInnerHTML={ {__html: this.props.message.text} }></span>
                </a>
                <div className="change-address" onClick={this.changeAddress} style={this.state.addressChanged || !this.props.canChangeAddress || this.props.changeAddress === null ? {display: 'none'} : {}}>Change address</div>
                <div className="message-time" dangerouslySetInnerHTML={ {__html: `Today ${this.props.message.time}`} } />
                {
                    (()=>{
                        if(parseInt(this.props.message.direction) === 2) {
                            return(<ReadSign />)
                        }
                    })()
                }
            </div>
        );
    }
}

googleMapsMessage.propTypes = {
    canChangeAddress: PropTypes.bool,
    changeAddress: PropTypes.func
};

googleMapsMessage.defaultProps = {
    canChangeAddress: false,
    changeAddress: null
};

export default googleMapsMessage;